<template>
  <div class="img-component-wrapper">
    <div class="mask"></div>

    <span class="close common-btn"
      @click="handleClose"><i class="el-icon-circle-close"></i>
    </span>

    <div v-show="btnFlag">
      <span class="prev common-btn"
        @click="handlePrev"><i class="el-icon-arrow-left"></i></span>
      <span class="next common-btn"
        @click="handleNext"><i class="el-icon-arrow-right"></i></span>
    </div>

    <span class="toggle common-btn"
      v-if="videoList.length && imgList.length"
      @click="imgShow = !imgShow">{{ imgShow ? '切换查看视频' : '切换查看图片' }}</span>

    <div class="img-container" v-show="imgShow">
      <img v-if="domainFlag"
        alt="图片加载失败"
        style="margin-left: 1px;margin-top: 1px;"
        @mousedown="handleImgMousedown"
        :src="$imgURL + imgList[imgIndex]"
        draggable="false"
        ref="img" />
      <img v-else
           alt="图片加载失败"
           style="margin-left: 1px;margin-top: 1px;"
           @mousedown="handleImgMousedown"
           :src="imgList[imgIndex]"
           draggable="false"
           ref="img" />
    </div>

    <div class="img-container" v-show="!imgShow">
      <video type="video/mp4" :src="$imgURL + videoList[0]" controls>你的浏览器不支持video</video>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    imgList: Array,
    videoList: Array,
    domainFlag: Boolean,
    index: {
      type: Number,
      default: 0
    },
    current: {
      type: String,
      default: 'image'
    }
  },
  data () {
    return {
      imgIndex: this.index,
      imgShow: true,
      currentImg: '',
      regionTimer: 0,
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 0,
      marginLeft: 0,
      marginTop: 0
    }
  },
  computed: {
    btnFlag () {
      return this.imgShow && this.imgList.length > 1
    },
    currentImg () {
      if (this.imgShow && this.imgList.length > 0) {
        return this.imgList[this.imgIndex]
      }
      return ''
    }
  },
  created () {
    if (this.imgList.length <= 0) {
      this.imgShow = false
    }

    document.body.addEventListener('mouseup', this.handleMouseup)
    document.body.addEventListener('mouseout', this.handleMouseout)
  },
  mounted () {
  },
  unmounted () {
    document.body.removeEventListener('mouseup', this.handleMouseup)
    document.body.removeEventListener('mouseout', this.handleMouseout)
  },
  watch: {
    imgIndex (newV) {
      if (newV > this.imgList.length - 1) {
        this.imgIndex = 0
      } else if (newV < 0) {
        this.imgIndex = this.imgList.length - 1
      }
    }
  },

  methods: {
    handleImgMousedown (e) {
      this.x1 = e.x
      this.y1 = e.y
      this.marginLeft = Number(this.$refs.img.style.marginLeft.match(/\\-{0,1}[0-9]/g).join(''))
      this.marginTop = Number(this.$refs.img.style.marginTop.match(/\\-{0,1}[0-9]/g).join(''))
      document.body.addEventListener('mousemove', this.handleMousemove)
    },
    handleMouseup () {
      this.x1 = 0
      this.y1 = 0
      clearTimeout(this.regionTimer)
      this.regionTimer = 0
      document.body.removeEventListener('mousemove', this.handleMousemove)
    },
    handleMousemove (e) {
      if (this.regionTimer) {
        return
      }
      this.regionTimer = setTimeout(() => {
        this.x2 = e.x
        this.y2 = e.y
        this.imgRemove(this.x2 - this.x1, this.y2 - this.y1)
        this.regionTimer = 0
      }, 5)
    },
    handleMouseout () {
      this.x1 = 0
      this.y1 = 0
      clearTimeout(this.regionTimer)
      this.regionTimer = 0
      document.body.removeEventListener('mousemove', this.handleMousemove)
    },

    handlePrev () {
      this.imgIndex = this.imgIndex - 1
    },
    handleNext () {
      this.imgIndex += 1
    },
    imgRemove (x, y) {
      this.$refs.img.style.marginLeft = (this.marginLeft + x) + 'px'
      this.$refs.img.style.marginTop = (this.marginTop + y) + 'px'
    },

    handleClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang='scss' scoped>

.img-component-wrapper{
  position: fixed;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 0;
  .mask{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: .5;
    background: #000;
  }

  .prev{
    left: 200px;
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
    border-color: #fff;
  }
  .next{
    right: 40px;
    text-indent: 2px;
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
    border-color: #fff;
  }
  .common-btn{
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    opacity: .8;
    cursor: pointer;
    box-sizing: border-box;
    user-select: none;
  }
  .close{
    top: 20px;
    right: 50px;
    width: 40px;
    height: 40px;
    font-size: 40px;
    color: #fff;
    opacity: 0.8;
  }
  .toggle{
    bottom: 30px;
    left: 50%;
    padding: 8px 20px;
    font-size: 12px;
    color: #fff;
    border-radius: 15px;
    background-color: #606266;
    transform: translateX(-50%);
  }
  .img-container{
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    >img{
      // max-width: 100%;
      // max-height: 100%;
    }
    >video{
      width: 600px;
      height: 450px;
      background: #000;
      border: none;
      outline: none;
    }
  }
}

</style>
